<template>
  <div class="vprogbakc">
    <div class="val1" :style="{backgroundColor:color1,width:value1+'%'}"></div>
    <div class="val2" :style="{backgroundColor:color2,width:value2+'%'}"></div>
  </div>
</template>

<script>
export default {
  name: 'DoubleProgressBar',
  props: {
    color1:{
      type:String,
      default:"var(--ek-color-primary)"
    },
    color2:{
      type:String,
      default:"#f300ffbf"
    },
    value1:{
      type:Number,
      default:0
    },
    value2:{
      type:Number,
      default:0
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.vprogbakc {
    height: 10px;
    background: var(--ek-card-progress-bgColor);
    border-radius: 20px;
    position: relative;
}
.val1{
    height: 10px;
    background: var(--ek-color-primary);
    border-radius: 20px;
    width: 45%;
}
.val2{
    height: 10px;
    background: #f300ffbf;
    border-radius: 20px;
    position: absolute;
    width: 25%;
    top: 0px;
    left: 0px;
}
</style>
